import * as zod from "zod";
import { ReturnStatus } from "../return-status";

export enum CreationStatusError {
  TEMPORAL_START_FAILED = "TEMPORAL_START_FAILED",
}

const CreationStatusErrorSchema_ = zod.enum(CreationStatusError);
export const CreationStatusErrorSchema: zod.ZodType<CreationStatusError> =
  CreationStatusErrorSchema_;

const SubmitDraftReturnResultSchema_ = zod.object({
  returnId: zod.string(),
  returnStatus: zod.enum(ReturnStatus).optional(),
  creationStatusError: CreationStatusErrorSchema.optional(),
  customerAuthToken: zod.string().optional(),
});
export const SubmitDraftReturnResultSchema: zod.ZodType<SubmitDraftReturnResult> =
  SubmitDraftReturnResultSchema_;
export interface SubmitDraftReturnResult extends zod.infer<
  typeof SubmitDraftReturnResultSchema_
> {}
